export let langCheck = {
	start: function(targetBlock){
		const pages = targetBlock.querySelectorAll("[data-page]");
		pages.forEach(($p) => {
			const isNewsDetail = $p.querySelector("article.news_detail");
			const isProductDetail = $p.querySelector(".product__info-wrapper .b-materials");
			if( isNewsDetail ){
				const $ja = $p.querySelector(".c-ttl_page span.ja");
				if (!$ja) return;
				const text = $ja.textContent || "";
				$ja.innerHTML = langCheck.wrapLangSpans(text.trim());
			}else if( isProductDetail ){
				let $ps = isProductDetail.querySelectorAll("p");
				$ps.forEach( ($p, index) => {
					let text = $p.textContent || "";
					$p.innerHTML = langCheck.wrapLangSpans(text.trim());
				});
			}else{
				return
			}
		});
	},

	// テキストの中の「日本語の塊」か「英字/数字の塊」だけを一括で拾って包む
	wrapLangSpans: function(text){
		// 日本語 or 英字/数字/一部記号 の“塊”を1回でマッチ
		const token = /([\p{Script=Hiragana}\p{Script=Katakana}\p{Script=Han}ー]+|[\p{Script=Latin}0-9&.,'’"()\-\/]+)/gu;
		
		const esc = (s) => s.replace(/[&<>"']/g, m => (
			{ "&":"&amp;", "<":"&lt;", ">":"&gt;", '"':"&quot;", "'":"&#39;" }[m]
		));
		
		return text.replace(token, (m) => {
			const isJa = /[\p{Script=Hiragana}\p{Script=Katakana}\p{Script=Han}]/u.test(m);
			return `<span class="${isJa ? "ja" : "en"}">${esc(m)}</span>`;
		});
	}
};